import React, {FC} from "react";
import {useHistory} from "react-router-dom";
import {useEditorLocation} from "../../../editor/editor.hook";
import {useCreateWorker} from "../redux/workers.hook";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputAdornment,
    makeStyles,
    Typography
} from "@material-ui/core";
import {ErrorMessage, Form, Formik} from "formik";
import {FormikTextField} from "../../../form/FormikTextField";
import {FormikServiceCheckBoxes} from "../../services/redux/FormikServiceCheckBoxes";
import {CreateWorkerData} from "../redux/types";
import {Euro} from "@material-ui/icons";
import {FormikSalutationSelect} from "../../../sharedComponents/FormikSalutationSelect";
import {workerValidationSchema} from "./workerValidationSchema";
import {FormikDcbAddressInput} from "../../../sharedComponents/DcbAddressInput";
import {Address} from "../../../redux/types";

const useStyles = makeStyles(theme => ({
    formContainer: {
        paddingBottom: theme.spacing(4)
    },
    saveButton: {
        color: theme.palette.success.main
    },
    cancelButton: {
        color: theme.palette.error.main
    }
}));

const initialValues: CreateWorkerData = {
    active: true,
    firstName: '',
    lastName: '',
    email: '',
    address: undefined as unknown as Address,
    hourlyWage: 11,
    servicesIds: [],
    maxKmToOrder: 10,
    phone: '',
    salutation:  ""
};

export const CreateWorkerDialogForm: FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const {mode} = useEditorLocation();
    const {createWorker} = useCreateWorker();

    const [isLoading, setIsLoading] = React.useState(false);

    const dialogOpen = mode === 'create';

    const openDialog = () => history.replace(`${history.location.pathname}?mode=create`);
    const closeDialog = () => history.replace({search: undefined});

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                onClick={openDialog}
            >
                Neu
            </Button>
            <Dialog open={dialogOpen} onClose={closeDialog}>
                <DialogTitle>
                    <Typography variant="inherit" color="primary">
                        Neuer Arbeiter
                    </Typography>
                </DialogTitle>
                <Formik
                    initialValues={initialValues}
                    onSubmit={(dto) => {
                        setIsLoading(true);
                        createWorker(dto)
                            .then(() => {
                                closeDialog();
                            })
                            .catch(() => {
                            })
                            .finally(() => {
                                setIsLoading(false)
                            })
                    }}
                    validationSchema={workerValidationSchema}
                >
                    {({submitForm, resetForm}) => (
                        <Form>
                            <DialogContent className={classes.formContainer}>
                                <Grid container spacing={2}>
                                    <Grid item xs={2}>
                                        <FormikSalutationSelect/>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <FormikTextField fullWidth name={"firstName"} label="Vorname" required/>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <FormikTextField fullWidth name={"lastName"} label="Nachname" required/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            fullWidth
                                            name={"email"}
                                            label="Email"
                                            type="email"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            fullWidth
                                            name={"phone"}
                                            label="Telefon"
                                            type="phone"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikDcbAddressInput name={"address"} label="Adresse" textFieldProps={{required: true}}/>
                                       {/* <PlacesAutoComplete
                                            onPlaceSelected={selectedPlace => setFieldValue('address', selectedPlace)}
                                        />*/}
                                        <Typography color="error"><ErrorMessage name={'address.placeId'}/></Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormikTextField
                                            fullWidth
                                            suffix={" Km"}
                                            name={"maxKmToOrder"}
                                            label="Max. Kilometer zu Auftrag"
                                            type="number"
                                            required
                                            InputProps={{
                                                endAdornment: <InputAdornment position={"end"}>
                                                    Km
                                                </InputAdornment>
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormikTextField
                                            fullWidth
                                            name={"hourlyWage"}
                                            label="Stundenlohn"
                                            type="number"
                                            suffix={" €/h"}
                                            required
                                            InputProps={{
                                                endAdornment: <InputAdornment position={"end"}>
                                                    <Euro color="action" fontSize="small"/>
                                                </InputAdornment>
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikServiceCheckBoxes name={"servicesIds"} label={"Dienstleistungen"}/>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                {isLoading ?
                                    <CircularProgress/> :
                                    (<>
                                        <Button className={classes.cancelButton}
                                                onClick={() => {
                                                    closeDialog();
                                                    resetForm();
                                                }}>
                                            Abbrechen
                                        </Button>
                                        <Button className={classes.saveButton}
                                                onClick={submitForm}>
                                            Speichern
                                        </Button>
                                    </>)}
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    )
}
